import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

interface IPaymentModalProps {
    handlePayModalClose: any;
}

const PaymentModal: React.FC<IPaymentModalProps> = (props: IPaymentModalProps) => {
  const { handlePayModalClose } = props;

  return (
    <div className='new-api-modal-paper'>
      <div className='api-modal-head'>
        <div className='api-icon-div'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
        <svg onClick={handlePayModalClose} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
          <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
        </svg>
      </div>
      <div className='api-modal-content'>
        <div className='api-modal-head-words'>
          <div className='api-modal-head-title'>
            <h1>Uh oh! You need an API payment plan</h1>
          </div>
          <h2>To access BITE API, you must set your monthly API meter preferences. </h2>
        </div>
      </div>

      <div className='new-api-modal-btns'>
        <Button
          onClick={handlePayModalClose}
          sx={{ color: '#BDBEC1', border: '1px solid #2E3036', textTransform: 'none', width: '50%', padding: '10px 14px', borderRadius: '8px' }}
        >Cancel
        </Button>
        <Link to={{
          pathname: '/profile',
          state: {
            linkTab: 'Plans'
          } }}
        style={{ width: '50%' }}><Button
            sx={{ color: '#EFF1F6', background: '#4895EF', textTransform: 'none', width: '100%', padding: '10px 14px', borderRadius: '8px' }}
          >View Plans
          </Button></Link>

      </div>
    </div>
  );
};

export default PaymentModal;
